import { BankAccountModel } from 'api-hooks/bank-account';
import { ChequeGiroModel } from 'api-hooks/cheque-giro';
import { CustomerBillingModel, CustomerModel } from 'api-hooks/customer';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { PaymentMethodModel } from 'api-hooks/payment-method';
import { SaleModel } from 'api-hooks/sale/common';
import { Expose, Type } from 'class-transformer';
import { ReleaseStatusEnum } from 'common/constants/enum';

export class PaymentableModel {
  id: string;
  name: string;
  status: string;
  type: string;

  @Expose({ name: 'available_at' })
  @Type(() => Date)
  availableAt: Date;

  @Expose({ name: 'bank_account' })
  @Type(() => BankAccountModel)
  bankAccount: BankAccountModel;

  @Expose({ name: 'cheque_giro' })
  @Type(() => ChequeGiroModel)
  chequeGiro: ChequeGiroModel;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'expired_at' })
  @Type(() => Date)
  expiredAt: Date;

  @Expose({ name: 'reference_number' })
  referenceNumber: string;

  @Expose({ name: 'issued_at' })
  @Type(() => Date)
  issuedAt: Date;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt: Date;
}

export class RefundReleaseUserModel {
  id: string;
  status: ReleaseStatusEnum;
  number: string;
  reason: string;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'requested_at' })
  @Type(() => Date)
  requestedAt: Date;

  @Type(() => CustomerModel)
  customer: CustomerModel;

  @Expose({ name: 'customer_billing' })
  @Type(() => CustomerBillingModel)
  customerBilling: CustomerBillingModel | null;

  @Expose({ name: 'payment_method' })
  @Type(() => PaymentMethodModel)
  paymentMethod: PaymentMethodModel;

  @Type(() => PaymentableModel)
  paymentable: PaymentableModel;

  @Type(() => SaleModel)
  sale: SaleModel;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class RefundReleaseUserLiteModel {
  id: string;
  customer: string;
  number: string;
  reason: string;
  status: string;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'requested_at' })
  @Type(() => Date)
  requestedAt: Date;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

// Result
export class CheckApprovalReleaseUserModel {
  approval: boolean | null;
}

//query
export class getRefundReleaseUsersInput {
  params: {
    page: number;
    limit?: number;
    filter?: string;
    sort?: string;
    q?: string;
    status?: string;
  };
}

export class getRefundReleaseUserInput {
  id: string;
}

//mutation
export class RefundReleaseUserMutationInput {}

export class RefundReleaseUserMutationUpdate {
  id: string;
  body: RefundReleaseUserMutationInput;
}
export class RefundReleaseUserMutationDelete {
  id: string;
}

export class PrintRefundReleaseUserMutationInput {
  id: string;
}

export type RefundReleaseUserInput = {
  releaseSaleId: string;
};
